import {
    CardInfo,
    IssuingClient,
    PayloadCardDetails,
    PayloadCardAction,
    DocumentRequest,
    ImportedFiles,
    SettlementFileResponse,
    SettlementCutOff,
    IssuingClientEvent,
    CardEvent,
} from "../../../models/IssuingClientsModel";
import { Merchant } from "../../../models/MerchantModel";
import { PagedResult, Result } from "../../../models/Result";
import { SearchRequestBaseModel } from "../../../models/SearchRequestModel";
import { httpService } from "../../HttpService";

class IssuingApiService {
    enrollment: string = "api/v1/Enrollment";

    card: string = "api/v1/Card";
    reports: string = "api/v1/Reports";

    getClients = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<IssuingClient[]>> =>
        await httpService.getPage<IssuingClient[]>(`${this.enrollment}/get-clients`, searchRequest);
    updateClientDetails = async (payload: any): Promise<Result<IssuingClient>> => {
        return await httpService.post<IssuingClient>(`${this.enrollment}/create-update-client`, payload);
    };
    updateClientStatus = async (payload: any): Promise<Result<IssuingClient>> => {
        return await httpService.post<IssuingClient>(`${this.enrollment}/status-update`, payload);
    };
    getImportedFiles = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<ImportedFiles[]>> =>
        await httpService.getPage<ImportedFiles[]>(`${this.reports}/files-imported`, searchRequest);
    getSettlementCutOffsFiles = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<SettlementCutOff[]>> =>
        await httpService.getPage<SettlementCutOff[]>(`${this.reports}/settlement-cut-offs`, searchRequest);

    getIcardTransactionsFiles = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<ImportedFiles[]>> =>
        await httpService.getPage<ImportedFiles[]>(`${this.reports}/transactions-at-icard`, searchRequest);

    getFileDetails = async (fileId: number): Promise<Result<SettlementFileResponse>> =>
        await httpService.get<SettlementFileResponse>(`${this.reports}/file-details/${fileId}`);

    getClientDetails = async (IndividualId: number): Promise<Result<IssuingClient>> => {
        return await httpService.post<IssuingClient>(`${this.enrollment}/get-client/${IndividualId}`, null);
    };
    updateCardStatus = async (payload: PayloadCardAction): Promise<Result<IssuingClient>> => {
        return await httpService.post<IssuingClient>(`${this.card}/status/update`, payload);
    };
    updatePinStatus = async (payload: PayloadCardAction): Promise<Result<IssuingClient>> => {
        return await httpService.post<IssuingClient>(`${this.card}/PinUnblock`, payload);
    };
    getClientICards = async (individualId: number): Promise<Result<CardInfo[]>> =>
        await httpService.post<CardInfo[]>(`${this.card}/GetIndividualCardsAll/${individualId}`, null);

    deleteRequestDocument = async (payload: {
        individualId: number;
        documentRequestId: number;
        fileId: number
    }): Promise<Result<CardInfo>> =>
        await httpService.post(`${this.enrollment}/documents-upload/remove-file`, payload);
    
    getClientDocumentRequests = async (individualId: number): Promise<Result<DocumentRequest[]>> =>
        await httpService.post<DocumentRequest[]>(`${this.enrollment}/get-document-requests/${individualId}`, null);
    getCardDetails = async (payload: PayloadCardDetails): Promise<Result<CardInfo>> =>
        await httpService.post<CardInfo>(`${this.card}/GetCardDetails`, payload);

    getCardEvents = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<CardEvent[]>> =>
        await httpService.getPage<CardEvent[]>(`${this.card}/GetCardEvents`, searchRequest);
    uploadDocument(payload: {
        individualId: number;
        documentRequestId: number;
        files: {
            fileName: string;
            fileContent: string;
        }[];
    }) {
        return httpService.post(`${this.enrollment}/documents-upload/add-files`, payload);
    }
    submitDocuments(payload: { individualId: number; documentRequestId: number }) {
        const { documentRequestId, ...body } = payload;

        return httpService.post(`${this.enrollment}/documents-upload/send-files`, body, {
            params: {
                request: documentRequestId,
            },
        });
    }

    getClientEvents = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<IssuingClientEvent[]>> =>
        await httpService.getPage<IssuingClientEvent[]>(`${this.enrollment}/get-client-events`, searchRequest);
}

const issuingApiService = new IssuingApiService();

export { issuingApiService };
